import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import T from '@prisjakt/ui-translate';
import { bemGenerator } from '@prisjakt/ui-base';
import { InView } from 'react-intersection-observer';
import { AppContext } from '@prisjakt/ui-app-context';
import ErrorBoundary from '../error-boundary';
import { getAdService } from './services';
import { getAdContextCookie } from './helpers/cookie';

import './index.scss';

const styles = bemGenerator('pj-ui-ad-container', ['label']);

const IN_VIEW_THRESHOLD = [0];

const AdContainer = props => {
  const context = useContext(AppContext);
  const serviceName =
    getAdContextCookie().service || context.market.ads.service;

  const service = getAdService(serviceName);
  return (
    <service.container service={service} {...props}>
      <span className={styles.label}>
        <T domain="common">ads.label</T>
      </span>
    </service.container>
  );
};

class AdContainerWithVisibility extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChangeHandler = this.onChange.bind(this);
    this.state = {
      isVisible: false,
    };
  }

  onChange(inView) {
    const { isVisible } = this.state;
    if (isVisible !== inView) {
      this.setState({ isVisible: inView });
    }
  }

  render() {
    const { isVisible } = this.state;
    const { className, renderWhenInScreen, triggerPoint } = this.props;

    return (
      <InView
        threshold={IN_VIEW_THRESHOLD}
        onChange={this.onChangeHandler}
        rootMargin={`0px 0px ${triggerPoint}px 0px`}
      >
        {({ ref }) => (
          <div ref={ref} className={className} data-test="AdContainer">
            <AdContainer
              {...this.props}
              isVisible={renderWhenInScreen ? !!isVisible : true}
            />
          </div>
        )}
      </InView>
    );
  }
}

AdContainerWithVisibility.contextType = AppContext;

AdContainerWithVisibility.propTypes = {
  renderWhenInScreen: PropTypes.bool,
  className: PropTypes.string,
  onStatusChange: PropTypes.func,
  triggerPoint: PropTypes.number,
};

AdContainerWithVisibility.defaultProps = {
  renderWhenInScreen: true,
  className: undefined,
  onStatusChange: () => {},
  triggerPoint: 300,
};

const AdContainerWithErrorBoundary = props => (
  <ErrorBoundary onError={() => null}>
    <AdContainerWithVisibility {...props} />
  </ErrorBoundary>
);

export default AdContainerWithErrorBoundary;
